export class Activation {
  _id = null;
  name = null;
  code = null;
  teams = 1;
  playersPerTeam = 1;
  settings = null;
  createAt = null;
  updatedAt = null;
}